import styled from 'styled-components'
import React, { useEffect, useState } from 'react'
// JSON data
import Links from './header.json'

// styled components
const NavigationHeader = styled.header`
  text-align: center;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
  height: 65px;
`

const UnOrderedList = styled.ul`
  display: inline-block;
  padding-left: 0;
  list-style: none;
  padding: 20px;
  margin-bottom: 0;
  -webkit-transition: all 0.5s;
  transition: all 0.5s;
`

const ListItem = styled.li`
  display: inline-block;
  margin: 10px;
`

const ListItemLink = styled.a`
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #009dfe;
  font-size: 0.8em;
  font-weight: bold;

  &:focus {
    color: #444;
    text-decoration: none;
  }

  &:hover {
    color: #009dfe;
    text-decoration: underline;
  }
`
const Header = () => {
  const [navStyle, setNavStyle] = useState('navbar-fixed-top');
  const [activeLink, setActiveLink] = useState('');

  useEffect(() => {
    // prepare section ids from Links (expects href like "#about")
    const sectionIds = Links.map(l => (l.href || '').startsWith('#') ? l.href.slice(1) : null).filter(Boolean);

    const getOffsets = () =>
      sectionIds.map(id => {
        const el = document.getElementById(id);
        return { id, top: el ? el.offsetTop : Infinity };
      });

    let offsets = getOffsets();

    const headerThreshold = 100; // when to add bg-nav; adjust if needed
    const headerHeight = 80; // adjust for your header height so highlight aligns

    const handleScroll = () => {
      const y = window.pageYOffset || document.documentElement.scrollTop;

      // navbar background
      const style = y > headerThreshold ? 'navbar-fixed-top bg-nav' : 'navbar-fixed-top';
      setNavStyle(style);

      // active section detection
      let active = '';
      for (let i = 0; i < offsets.length; i++) {
        const cur = offsets[i];
        const next = offsets[i + 1];
        const start = Math.max(0, cur.top - headerHeight);
        const end = next ? Math.max(0, next.top - headerHeight) : Infinity;
        if (y >= start && y < end) {
          active = cur.id;
          break;
        }
      }
      setActiveLink(active);
    };

    // initial compute & bind
    handleScroll();
    const onResize = () => {
      offsets = getOffsets();
      handleScroll();
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', onResize);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return (
    <NavigationHeader className={navStyle}>
      <nav>
        <UnOrderedList>
          {Links.map((link, index) => {
            const id = (link.href || '').startsWith('#') ? link.href.slice(1) : link.href;
            return (
              <ListItem key={index}>
                <ListItemLink
                  style={
                    activeLink === id
                      ? {
                          color: '#009DFE',
                          textDecoration: 'underline'
                        }
                      : {}
                  }
                  href={link.href}>
                  {link.lable}
                </ListItemLink>
              </ListItem>
            )
          })}
        </UnOrderedList>
      </nav>
    </NavigationHeader>
  );
};

export default Header
